import store2 from "store2";
import { baseUrl } from "../api/config";
import { Technician, UserFromAPI } from "../types/auth.types";
import { FormatedField } from "../types/fields.types";


export type TechnicianInfo = {
    name: string;
    signatureUrl: string | null;
    title: string | null;
    license: string | null
}

type StrictTechnician = Pick<Technician, "signature" | "main_professional_title" | "license_number">;
type StrictUser = {
    technician_id: Array<StrictTechnician>;
    first_name: string;
    last_name: string;
} & Partial<
    Omit<UserFromAPI, "technician_id" | "first_name" | "last_name">
    >;

export const makeTechnicianInfo = (user: StrictUser, mainProfessionalTitleField?: FormatedField):TechnicianInfo => {
    const signatureId = user.technician_id[0]?.signature;

    const signatureUrl = signatureId
        ? `${baseUrl}/assets/${signatureId}?access_token=${store2.get("auth").access_token}`
        : null;

    const professionalTitle = mainProfessionalTitleField ? getTechnicianTitle(user.technician_id[0]?.main_professional_title, mainProfessionalTitleField) : null
    
    return {
        name: `${user.first_name} ${user.last_name}`,
        signatureUrl,
        title: professionalTitle,
        license: user.technician_id[0]?.license_number ?? null
    };
};

const getTechnicianTitle = (value: string, mainProfessionalTitleField: FormatedField) => {
    const choices = mainProfessionalTitleField?.settings?.options?.choices;
    const matchedChoice = choices?.find((choice: any) => choice.value === value);
    return matchedChoice?.text || null;
};